/**
 * Política de contraseñas de las cuentas administrativas.
 * Debe coincidir con App\Http\Requests\PasswordCambiarRequest::politica().
 */
export const MINIMO_PASSWORD = 8;

export const reglasPassword = [
    (v) => !!v || 'Campo requerido',
    (v) => (!!v && v.length >= MINIMO_PASSWORD) || `La contraseña debe tener al menos ${MINIMO_PASSWORD} caracteres.`,
    (v) => /[A-Z]/.test(v || '') && /[a-z]/.test(v || '') || 'Debe tener mayúsculas y minúsculas.',
    (v) => /[0-9]/.test(v || '') || 'Debe tener al menos un número.',
    (v) => /[^A-Za-z0-9]/.test(v || '') || 'Debe tener al menos un símbolo.',
];

/** Contraseña temporal legible, sin caracteres ambiguos (0/O, 1/l/I). */
export function generarPasswordTemporal(largo = 12) {
    const grupos = ['ABCDEFGHJKLMNPQRSTUVWXYZ', 'abcdefghijkmnpqrstuvwxyz', '23456789', '#?!@$%&*-'];
    const azar = (n) => {
        const valores = new Uint32Array(1);
        window.crypto.getRandomValues(valores);
        return valores[0] % n;
    };

    const caracteres = grupos.map(grupo => grupo[azar(grupo.length)]);
    const todos = grupos[0] + grupos[1] + grupos[2];

    while (caracteres.length < largo) {
        caracteres.push(todos[azar(todos.length)]);
    }

    for (let i = caracteres.length - 1; i > 0; i--) {
        const j = azar(i + 1);
        [caracteres[i], caracteres[j]] = [caracteres[j], caracteres[i]];
    }

    return caracteres.join('');
}
